import type { LocalDate } from '@shared/calendar';

export type UserStatusFilter = 'active' | 'deactivated' | 'all';

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: 'admin' | 'user';
  status: 'active' | 'deactivated';
  startDate: LocalDate;
  lastLoginAt: string | null;
  deactivatedAt: string | null;
  createdAt: string;
  isSelf: boolean;
  accessSyncIssue: { operation: 'grant' | 'revoke'; errorCode: string; attempts: number; lastFailedAt: string } | null;
}

export interface AdminUserList {
  items: AdminUser[];
  meta: { activeAdminCount: number };
}

export type AccessSyncResult = { status: 'ok' } | { status: 'failed'; code: string; message: string };

export interface UserWithAccessSync {
  user: AdminUser;
  accessSync: AccessSyncResult;
}

/** Same wording as the server (src/lib/user-locks.ts). */
export const LAST_ADMIN_MESSAGE = 'Clockit needs at least one active Admin. Make someone else an Admin first.';
